import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import TableWithSkeleton from '../../../components/global/table/TableWithSkeleton.jsx';
import MyPagination from '../../../components/global/pagination/Pagination.jsx';
import { GetSendEmailUserDetailApi } from '../../../api/request/emailMarketing.js';
import UserAvatar from '../../../components/global/avtar/UserAvatar.jsx';
import moment from 'moment';

const columns = [
  { title: 'User', dataIndex: 'user' },
  { title: 'Retry Count', dataIndex: 'retryCount' },
  { title: 'Error Message', dataIndex: 'errorMessage' },
  { title: 'Status', dataIndex: 'status' },
  // { title: 'Sent Date', dataIndex: 'sentAt' },
];

export default function EmailUserDetail() {
  const { sendEmailId: templateId } = useParams();

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalRecord, setTotalRecord] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  const getUserDetail = async () => {
    try {
      setIsLoading(true);
      const params = new URLSearchParams({
        PageNumber: page,
        PageSize: pageSize,
        ApplyPagination: true,
      }).toString();

      const { data: apiResponse } = await GetSendEmailUserDetailApi(templateId, params);

      if (apiResponse?.success) {
        const rows = (apiResponse?.data ?? []).flatMap((templateItem) => {
          const templateSubject = templateItem?.subject;
          const allMarketing = templateItem?.marketing ?? [];

          return allMarketing.flatMap((marketingItem) => {
            const users = marketingItem?.users ?? [];

            return users.map((user, index) => {
              const email = user?.email || '--';
              const rawStatus = user?.status || marketingItem?.status || '--';
              const statusText = String(rawStatus);
              const statusKey = statusText.toLowerCase();
              const statusClass =
                statusKey === 'sent' || statusKey === 'completed'
                  ? 'success_tag'
                  : statusKey === 'pending' || statusKey === 'processing'
                    ? 'bg-yellow-200 text-yellow-700'
                    : 'fail_tag';

              return {
                key: user?.userId ?? `${marketingItem?.marketingId}-${index}`,
                ...user,
                user: <UserAvatar data={{ name: user?.userName, email }} />,
                sentAt: user?.sentAt ? moment(user?.sentAt).format('DD-MM-YYYY, hh:mm A') : '--',
                errorMessage: user?.errorMessage || '--',
                status: (
                  <span className={`px-3 py-1 rounded-full uppercase text-xs text-center ${statusClass}`}>
                    {statusText}
                  </span>
                ),
              };
            });
          });
        });

        setData(
          rows
        );

        setTotalRecord(apiResponse?.totalItems ?? 0);

        // Keep local pagination in sync if API returns it
        if (typeof apiResponse?.pageNumber === 'number' && apiResponse.pageNumber !== page) {
          setPage(apiResponse.pageNumber);
        }
        if (typeof apiResponse?.pageSize === 'number' && apiResponse.pageSize !== pageSize) {
          setPageSize(apiResponse.pageSize);
        }
      }
    } catch (e) {
      // swallow (UI will simply stop loading)
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!templateId) return;
    getUserDetail();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [templateId, page, pageSize]);

  return (
    <div className="border-2 border-light rounded-xl p-4">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-4">
        <p className="text-[#2F2B3D] text-xl font-semibold m-0">Email Recipients</p>
      </div>

      <div className="my-6">
        <TableWithSkeleton columns={columns} data={data} loading={isLoading} page={page} pageSize={pageSize} />
        <MyPagination
          total={totalRecord}
          page={page}
          setPage={setPage}
          pageSize={pageSize}
          setPageSize={setPageSize}
        />
      </div>
    </div>
  );
}

